<div class="mt-5 col-md-12">
  <app-create-organization [organizations]="organizations"
                           [categories]="categories"
                           [users]="users"
                           [prefill]="organizationToEdit"
                           (update)="updateOrganizationsList().subscribe()"
  ></app-create-organization>
</div>

<p class="mt-5 col-md-12 bold">Existing Organizations:</p>
<div class="mb-3">
  <app-organization-management-single *ngFor="let organization of organizations"
                                  (edit)="editOrganization($event)"
                                  (delete)="openDeleteConfirmPopup($event)"
                                  [organization]="organization"
  ></app-organization-management-single>
</div>

<ng-template #deletePopup>
  <app-delete-popup (delete)="deleteOrganization($event)"
                    [mainText]="'delete_popup_main_text_organization' | t">
  </app-delete-popup>
</ng-template>
